import { appRouters } from '../../router/router'
import Util from '../../lib/util';
import Vue from 'vue';
import { Store, Module, ActionContext } from 'vuex'
import Vuex from 'vuex';
// import appconst from '../../lib/appConst'
import Oidc from 'oidc-client'
import axios from 'axios';

Vue.use(Vuex);

interface AppState {
    cachePage: Array<any>;
    lang: string;
    isFullScreen: boolean;
    openedSubmenuArr: Array<any>;
    menuTheme: string;
    themeColor: string,
    pageOpenedList: Array<any>;
    currentPageName: string;
    currentPath: Array<any>;
    menuList: Array<any>;
    routers: Array<any>;
    //tagsList: Array<any>;
    messageCount: number;
    dontCache: Array<any>;
    noticeList: Array<any>;
    oidcUserManager: any;
    sidebarMenuVisible: boolean;
}
class AppModule implements Module<AppState, any>{
    namespaced = true;
    state = {
        cachePage: [],
        lang: '',
        isFullScreen: false,
        openedSubmenuArr: [],
        menuTheme: 'light',
        themeColor: '',
        pageOpenedList: [{
            meta: { title: 'PersonalCenterHomePage' },
            path: '',
            name: 'home'
        }],
        currentPageName: '',
        currentPath: [
            {
                meta: { title: 'PersonalCenterHomePage' },
                path: '',
                name: 'home'
            }
        ],
        menuList: [],
        routers: [
            //otherRouters,
            ...appRouters
        ],
        //tagsList: [...otherRouters.children],
        messageCount: 0,
        dontCache: [],
        noticeList: [{ read: false, type: 0, title: 'First notice', description: 'One day ago' }, { read: false, type: 1 }, { read: false, type: 0, title: 'Second notice', description: 'One month ago' }],
        oidcUserManager: new Oidc.UserManager(JSON.parse(process.env.VUE_APP_OIDC_CONFIG)),
        sidebarMenuVisible: true
    };
    mutations = {
        /**
         * OIDC登录
        */
        login(state: AppState) {
            state.oidcUserManager.signinRedirect();
        },

        /**
         * OIDC退出登录
        */
        logout(state: AppState) {
            Util.abp.auth.clearToken()
            localStorage.setItem('fdm-login-return-url', location.href)
            state.oidcUserManager.signoutRedirect();
        },
        // setTagsList(state: AppState, list: Array<any>) {
        //     state.tagsList.push(...list);
        // },
        updateMenuList(state: AppState) {
            let menuList: Array<Router> = [];
            appRouters.forEach((item, index) => {
                if (item.permission !== undefined) {
                    let hasPermissionMenuArr: Array<Router> = [];
                    hasPermissionMenuArr = item.children.filter(child => {
                        if (child.permission !== undefined) {
                            if (Util.abp.auth.hasPermission(child.permission)) {
                                return child;
                            }
                        } else {
                            return child;
                        }
                    });
                    if (hasPermissionMenuArr.length > 0) {
                        item.children = hasPermissionMenuArr;
                        menuList.push(item);
                    }
                } else {
                    if (item.children.length === 1) {
                        menuList.push(item);
                    } else {
                        let len = menuList.push(item);
                        let childrenArr = [];
                        childrenArr = item.children.filter(child => {
                            return child;
                        });
                        let handledItem = JSON.parse(JSON.stringify(menuList[len - 1]));
                        handledItem.children = childrenArr;
                        menuList.splice(len - 1, 1, handledItem);
                    }
                }
            });
            state.menuList = menuList;
        },
        changeMenuTheme(state: AppState, theme: string) {
            state.menuTheme = theme;
        },
        changeMainTheme(state: AppState, mainTheme: string) {
            state.themeColor = mainTheme;
        },
        addOpenSubmenu(state: AppState, name: any) {
            let hasThisName = false;
            let isEmpty = false;
            if (name.length === 0) {
                isEmpty = true;
            }
            if (state.openedSubmenuArr.indexOf(name) > -1) {
                hasThisName = true;
            }
            if (!hasThisName && !isEmpty) {
                state.openedSubmenuArr.push(name);
            }
        },
        closePage(state: AppState, name: any) {
            state.cachePage.forEach((item, index) => {
                if (item === name) {
                    state.cachePage.splice(index, 1);
                }
            });
        },
        initCachepage(state: AppState) {
            if (localStorage.cachePage) {
                state.cachePage = JSON.parse(localStorage.cachePage);
            }
        },
        removeTag(state: AppState, name: string) {
            state.pageOpenedList.map((item, index) => {
                if (item.name === name) {
                    state.pageOpenedList.splice(index, 1);
                }
            });
        },
        pageOpenedList(state: AppState, get: any) {
            let openedPage = state.pageOpenedList[get.index];
            if (get.argu) {
                openedPage.argu = get.argu;
            }
            if (get.query) {
                openedPage.query = get.query;
            }
            state.pageOpenedList.splice(get.index, 1, openedPage);
            localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        },
        clearAllTags(state: AppState) {
            state.pageOpenedList.splice(1);
            state.cachePage.length = 0;
            localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        },
        clearOtherTags(state: AppState, vm: Vue) {
            let currentName = vm.$route.name;
            let currentIndex = 0;
            state.pageOpenedList.forEach((item, index) => {
                if (item.name === currentName) {
                    currentIndex = index;
                }
            });
            if (currentIndex === 0) {
                state.pageOpenedList.splice(1);
            } else {
                state.pageOpenedList.splice(currentIndex + 1);
                state.pageOpenedList.splice(1, currentIndex - 1);
            }
            let newCachepage = state.cachePage.filter(item => {
                return item === currentName;
            });
            state.cachePage = newCachepage;
            localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        },
        setOpenedList(state: AppState) {
            //state.pageOpenedList = localStorage.pageOpenedList ? JSON.parse(localStorage.pageOpenedList) : [otherRouters.children[0]];
        },
        setCurrentPath(state: AppState, pathArr: Array<any>) {
            state.currentPath = pathArr;
        },
        setCurrentPageName(state: AppState, name: string) {
            state.currentPageName = name;
        },
        clearOpenedSubmenu(state: AppState) {
            state.openedSubmenuArr.length = 0;
        },
        increateTag(state: AppState, tagObj: any) {
            if (!Util.oneOf(tagObj.name, state.dontCache)) {
                state.cachePage.push(tagObj.name);
                localStorage.cachePage = JSON.stringify(state.cachePage);
            }
            state.pageOpenedList.push(tagObj);
        },
        hideSidebarMenu(state: AppState) {
            state.sidebarMenuVisible = false;
        },
        showSidebarMenu(state: AppState) {
            state.sidebarMenuVisible = true;
        }
    }
    actions = {
        async login(content: ActionContext<AppState, any>, payload: any) {
            let oidcConfig = JSON.parse(process.env.VUE_APP_OIDC_CONFIG);
            try {
                let res = await axios.post(oidcConfig.authority + "/connect/token", {
                    client_id: oidcConfig.client_id,
                    grant_type: 'password', //oidcConfig.grantType,
                    //client_secret: 'Fdm_secret_2024_22162549-de48-4367-9f10-b624d5eb268d', //oidcConfig.clientSecret,
                    username: `${payload.data.userNameOrEmailAddress}|${Util.abp.multiTenancy.getTenantIdCookie()}`,
                    password: payload.data.password
                }, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: [
                        function (data) {
                            let ret = ''
                            for (let it in data) {
                                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                            }
                            ret = ret.substring(0, ret.lastIndexOf('&'))
                            return ret
                        }
                    ],

                });
                return res;
            } catch (error) {
                return { status: 400 };
            }
        },

        async register(content: ActionContext<AppState, any>, payload: any) {
            let oidcConfig = JSON.parse(process.env.VUE_APP_OIDC_CONFIG);
            try {
                let res = await axios.post(oidcConfig.authority + "/account/register", {
                    // client_id: oidcConfig.client_id,
                    // grant_type: 'password', //oidcConfig.grantType,
                    //client_secret: 'Fdm_secret_2024_22162549-de48-4367-9f10-b624d5eb268d', //oidcConfig.clientSecret,
                    userName: payload.data.userName,
                    smsValidationCode: payload.data.smsValidationCode,
                    password: payload.data.password
                }, {
                    headers: {
                        'TenantId': Util.abp.multiTenancy.getTenantIdCookie()
                    },
                    transformRequest: [
                        function (data) {
                            let ret = ''
                            for (let it in data) {
                                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                            }
                            ret = ret.substring(0, ret.lastIndexOf('&'))
                            return ret
                        }
                    ]
                });

                return {
                    status: res.status,
                    success: (res as any).data.result.success,
                    result: (res as any).data.result
                };
            } catch (error) {
                const errorObject = error as any
                const message = errorObject.response.data.error.validationErrors[0].message
                return { status: errorObject.status, success: false, message: message };
            }
        },

        // async getUserInfo(content: ActionContext<AppState, any>, payload: any) {
        //     let oidcConfig = JSON.parse(process.env.VUE_APP_OIDC_CONFIG);
        //     await axios.post(oidcConfig.authority + "/connect/userinfo", null, {
        //         headers: {
        //             "Authorization": "Bearer " + payload.data
        //         }
        //     }).then(res => {
        //         localStorage.setItem('fdm-user-name', res.data.name);
        //     });
        // },
        // async logout() {
        //     // let oidcConfig = JSON.parse(process.env.VUE_APP_OIDC_CONFIG);
        //     // let token = Util.abp.auth.getToken();
        //     // await axios.get(oidcConfig.authority + "/connect/endsession?id_token_hint=" + token + "&post_logout_redirect_uri=")
        //     //     .then(res => {
        //     //         console.log(res);
        //     //     });
        //     Util.abp.auth.clearToken();
        //     localStorage.clear();
        // }

        async getSmsValidationCode(context: ActionContext<AppState, any>, payload: any) {
            let oidcConfig = JSON.parse(process.env.VUE_APP_OIDC_CONFIG);
            let reponse = await axios.get(oidcConfig.authority + '/account/getSmsValidationCode?mobile=' + payload.data);
            return reponse.data;
        },
    }
}
const appModule = new AppModule();
export default appModule;
